import { formatCellValue } from "@/components/contracts/table-utils";
import { DataTable } from "@/components/shared/data-table";
import type { PrivateHireFacility } from "@/lib/coach-manager/types";

export function PrivateHireFacilitiesTable({ facilities }: { facilities: PrivateHireFacility[] }) {
  if (facilities.length === 0) return null;

  return (
    <DataTable headers={[{ label: "Facility" }]}>
      {facilities.map((facility) => (
        <tr
          key={`${facility.PrivateHireMovementID}-${facility.Facility}`}
          className="border-b last:border-b-0"
        >
          <td className="px-4 py-2">{formatCellValue(facility.Facility)}</td>
        </tr>
      ))}
    </DataTable>
  );
}
